import React from "react";
import { LINKS } from "@consts";
import ErrorPage from "./ErrorPage";
import ForbiddenIcon from "./ForbiddenIcon";

const PermissionErrorPage = ({ height }) => {
  const pageLinks = [
    { url: "/", text: "Go to home page" },
    { url: LINKS.HYRO_SUPPORT, text: "Contact support" }
  ];

  return (
    <ErrorPage
      code="403"
      message="No permission"
      explanation="You don't have permission to view this content"
      links={pageLinks}
      Icon={ForbiddenIcon}
      testId="permission-error"
      height={height}
    />
  );
};

export default PermissionErrorPage;
